import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { BasicModalV2, TextButton } from '../../../../components/index.js';
import CustomModalHeader from '../../../Common/customComponents/CustomModalHeader.tsx';
import CustomTable from 'containers/Common/customComponents/CustomTable.tsx';
import { ptwApi } from '../../../../api/ptw.api.ts';
import { formattedDateTime } from 'utils';

interface IProps {
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  isModalOpen: boolean;
  ptwDSeq: number;
}

const columns = [
  { column: 'no', label: 'No', align: 'center', size: 60 },
  { column: 'userNm', label: 'Name', align: 'center', size: 140 },
  { column: 'approvalType', label: 'Type', align: 'center', size: 120 },
  {
    column: 'extendStatus',
    label: 'Status',
    align: 'center',
    size: 120,
    type: 'custom',
    custom: (row: any) => {
      let value;
      if (row.isFinish) {
        value = 'Complete';
      } else {
        value = 'Before';
      }
      return (
        <div className={'flex-row flex-row-just-center'}>
          <span className={`grid-approval-status ${value}`}>{value}</span>
        </div>
      );
    }
  },
  {
    column: 'lastModifiedDate',
    label: 'Time',
    align: 'center',
    size: 160,
    type: 'custom',
    custom: (row: any) => <span>{formattedDateTime(row.lastModifiedDate)}</span>
  },
  { column: 'comment', label: 'Comment', align: 'left', size: 200 }
];

const ExtensionHistoryModal = ({ isModalOpen, setIsModalOpen, ptwDSeq }: IProps) => {
  const [gridData, setGridData] = useState<any[]>([]);

  const modalClose = () => setIsModalOpen(false);

  useEffect(() => {
    if (!isModalOpen || !ptwDSeq) return;
    setGridData([]);
    ptwApi.getExtendHistory({ ptwDSeq }).then((r: any) => {
      const list = (r?.resultList ?? []).map((row: any, index: number) => ({
        ...row,
        no: index + 1
      }));
      setGridData(list);
    });
  }, [isModalOpen, ptwDSeq]);

  return (
    <BasicModalV2 open={isModalOpen} onClose={modalClose}>
      <CustomModalHeader title="Extension History" modalClose={modalClose} />
      <div className="custom-modal-body" style={{ width: '860px' }}>
        <div className="contents-box">
          <CustomTable
            columns={columns}
            data={gridData}
            setData={setGridData}
            isPaging={false}
            isCheck={false}
            className="min-w-100"
          />
          <div className="button-box" style={{ marginTop: '16px' }}>
            <TextButton
              className="cancel-style"
              variant="outlined"
              style={{ height: '40px' }}
              onClick={modalClose}
            >
              Close
            </TextButton>
          </div>
        </div>
      </div>
    </BasicModalV2>
  );
};

export default ExtensionHistoryModal;
